module.exports = __webpack_public_path__ + "img/goods7.87d02939.jpg";